import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { searchResultsFieldAliasMap } from 'app/shared/constants/search-results.constant';
import { FilterOperatorType } from 'app/shared/models/filter-operator-type.model';
import { MapFilterItem } from '../../map-filter-state.model';

@Component({
  selector: 'app-filter-text',
  templateUrl: 'filter-text.component.html',
  styleUrls: ['filter-text.component.scss'],
})
export class FilterTextComponent implements OnChanges {
  @Input()
  item: MapFilterItem;

  @Input()
  fields: __esri.Field[];

  filterTypeEq = FilterOperatorType.Eq;

  alias: string;
  get hasAlias() {
    return !!this.alias;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.item) {
      this.alias = searchResultsFieldAliasMap.get(this.item?.field);
    }
  }
}
